<template>
    <v-container>
        <div>
            <v-flex>
                <v-row>
                    <h1 class="page-title">Home</h1>
                    <v-spacer class="line"></v-spacer>
                    <hr>
                </v-row>
            </v-flex>

            <v-simple-table>
                <thead>
                <tr>
                    <th class="text-left">First Name</th>
                    <th class="text-left">Last Name</th>
                    <th class="text-left">Email Address</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{{user.firstName}}</td>
                    <td>{{user.lastName}}</td>
                    <td>{{user.email}}</td>
                </tr>
                </tbody>
            </v-simple-table>
        </div>

        <div v-if="user_role == 'restaurant'">
            <v-flex>
                <v-row>
                    <h1 class="page-title">Restaurants</h1>
                    <v-spacer class="line"></v-spacer>
                </v-row>
            </v-flex>
            <span v-if="restaurantsSearched.length === 0">No restaurants found</span>
            <div v-if="!is_mobile_version" class="restaurants-table">
                <v-simple-table>
                <thead>
                <tr>
                    <th class="text-left">Restaurant Name</th>
                    <th class="text-left">Location Address</th>
                    <th class="text-right">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="restaurant of restaurantsSearched" :key="restaurant.id">
                    <td>{{ restaurant.name }}</td>
                    <td><restaurant-address-modal :thisRestaurantId="restaurant.id"></restaurant-address-modal></td>
                    <td>
                        <edit-restaurant-profile-modal
                            :thisRestaurantData="restaurant"
                            @updated="loadData"
                        ></edit-restaurant-profile-modal>
                    </td>
                </tr>
                </tbody>
                </v-simple-table>
            </div>
            <div v-if="is_mobile_version">
                <v-card
                    color="elevation-1"
                    style="margin-bottom: 2px;"
                    no-gutters
                    tile
                    class="time-sheet-table__line"
                    v-for="restaurant in restaurantsSearched"
                    :key="restaurant.id"
                    >
                    <v-row>
                        <v-col>{{ restaurant.name }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col><restaurant-address-modal :thisRestaurantId="restaurant.id"></restaurant-address-modal></v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <edit-restaurant-profile-modal
                                :thisRestaurantData="restaurant"
                                @updated="loadData"
                            ></edit-restaurant-profile-modal>
                        </v-col>
                    </v-row>
                </v-card>
            </div>
        </div>
    </v-container>
</template>

<script>
    import Vue from 'vue'
    import {mapGetters} from 'vuex'
    import * as _ from 'lodash'

    export default {
        name: "Home",
        data() {
            return {
                user_role: void 0,
                thisRestaurantData: void 0,
                restaurants_list: [],
                is_mobile_version: false,
            }
        },
        created() {
            // -- detect mobile version
            let check = false;
            // eslint-disable-next-line
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);

            this.is_mobile_version = check;
        },
        computed: {
            ...mapGetters([
                'user',
                'isUserLoggedIn',
                'loading'
            ]),
            restaurantsSearched() {
                return this.restaurants_list;
            },
        },
        mounted: function () {
            this.loadData();
        },
        methods: {
            loadData() {
                if (localStorage.getItem("user")) {
                    let user = JSON.parse(localStorage.getItem("user"));
                    this.user_role = user.role;

                    let restaurants = [];
                    _.each(user.restaurants, restaurant => {
                        restaurants.push({
                            id: restaurant.id,
                            area_id: restaurant.area_id,
                            name: restaurant.name,
                            address: restaurant.address,
                            contactName: restaurant.contact_name,
                            telephone: restaurant.telephone,
                            map_latitude: restaurant.map_latitude,
                            map_longitude: restaurant.map_longitude,
                            meal: restaurant.meal,
                            uniform: restaurant.uniform,
                            cash_orders: restaurant.cash_orders,
                            waiting_location: restaurant.waiting_location,
                            other: restaurant.other,
                            bonus_target: restaurant.bonus_target,
                            logo_src: restaurant.logo_src,
                            service_agreement_src: restaurant.service_agreement_src,
                            email: user.email
                        });
                    });

                    this.restaurants_list = [];
                    Vue.nextTick(() => { // fix refresh restaurant-address-modal
                        this.restaurants_list = restaurants;
                    })
                }
            },
        }
    }
</script>

<style scoped>

</style>